// #3248 — the API refuses a magic-link action session (the 15-minute
// bp_action_session cookie) on every route outside its allowlist with
// 403 { error, code: 'ACTION_SESSION_OUT_OF_SCOPE' } (founder ruling D3,
// #3248 comment 6088037719). The session is still valid for its own action, so
// nothing is cleared: the user is sent to sign in, keeping where they were.
//
// Handled once, in apiFetch, and separately from TENANT_ACCESS_REVOKED
// (lib/tenantAccessRevoked.ts: 401, clears stored login, "access removed"):
// different status, different code, different handler, so neither can trigger
// the other.

import { isSafeRedirect } from './redirectGuard';

export const ACTION_SESSION_OUT_OF_SCOPE = 'ACTION_SESSION_OUT_OF_SCOPE';
export const ACTION_SESSION_OUT_OF_SCOPE_LOGIN_ERROR = 'action_session_out_of_scope';
export const ACTION_SESSION_OUT_OF_SCOPE_MESSAGE = 'Sign in to continue.';

let redirecting = false;

/** Test-only: reset the once-per-page guard. */
export function __resetActionSessionOutOfScopeGuardForTest(): void {
  redirecting = false;
}

export function isActionSessionOutOfScope(status: number, body: unknown): boolean {
  return status === 403
    && typeof body === 'object' && body !== null
    && (body as Record<string, unknown>).code === ACTION_SESSION_OUT_OF_SCOPE;
}

/**
 * Send the user to /login once, carrying the current path + search as
 * `redirect` when `isSafeRedirect` accepts it (dropped otherwise). Parallel
 * refusals don't each redirect (module-level guard); already on /login → no-op.
 * Returns true when it started the redirect.
 */
export function handleActionSessionOutOfScope(
  win: Pick<Window, 'location'> = window,
): boolean {
  if (redirecting) return false;
  if (win.location.pathname === '/login') return false;
  const here = `${win.location.pathname}${win.location.search}`;
  const query = new URLSearchParams({ error: ACTION_SESSION_OUT_OF_SCOPE_LOGIN_ERROR });
  if (isSafeRedirect(here)) query.set('redirect', here);
  redirecting = true;
  win.location.assign(`/login?${query.toString()}`);
  return true;
}
